<script setup>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { useSessionStore } from "./stores/session";
import AppShell from "./components/AppShell.vue";

const session = useSessionStore();
const router = useRouter();
onMounted(async () => {
  await session.restore();
  if (!session.user && router.currentRoute.value.name !== "login")
    router.replace("/giris");
});
</script>

<template>
  <div
    v-if="!session.ready"
    class="grid min-h-screen place-items-center bg-slate-100"
  >
    <div class="loader-ring" aria-label="Yukleniyor"></div>
  </div>
  <RouterView v-else-if="$route.meta.public" />
  <AppShell v-else-if="session.user"><RouterView /></AppShell>
</template>
